import React from 'react'
import Background from '../../../assets/backgrounds/join.svg'
import MovingBackground from '../../../partials/MovingBackground/MovingBackground'
import { FormattedMessage } from 'react-intl'
import Button from '../../../components/Button/Button'
import { Color, Direction } from '../../../utils/constants'
import { Link } from '../../../utils/helpers'
import Image from '../../../components/Image'

const id = 'page.about.join'

const Join = () => {
    return (
        <div className='grid md:grid-cols-2'>
            <div className='bg-purple relative overflow-hidden h-full'>
                <MovingBackground
                    component={Background}
                    classes={{ background: 'mix-blend-multiply', wrapper: 'h-full' }}
                >
                    <div className='flex flex-col justify-center w-full md:w-max mx-auto h-full text-white relative side-padding py-24 md:p-0 text-center md:text-left'>
                        <div className='md:max-w-[410px]'>
                            <div className='pb-10'>
                                <FormattedMessage id={id} tagName='h2' />
                            </div>
                            <span className='text-base'>
                                <FormattedMessage id={`${id}.description`} />
                            </span>
                        </div>
                        <div className='flex md:flex-row flex-col gap-3 pt-8'>
                            <Link to='https://careers.biomatter.ai/' external={true}>
                                <Button buttonColor={Color.WHITE} chevron={Direction.RIGHT} outerClasses='w-full'>
                                    <FormattedMessage id={`${id}.career`} tagName='h6' />
                                </Button>
                            </Link>
                            <Link to='/contact'>
                                <Button buttonColor={Color.WHITE} chevron={Direction.RIGHT} outerClasses='w-full'>
                                    <FormattedMessage id={`${id}.contact`} tagName='h6' />
                                </Button>
                            </Link>
                        </div>
                    </div>
                </MovingBackground>
            </div>
            <Image slug='join' className='w-full' alt='join-company' />
        </div>
    )
}

export default Join
